/*
 * @Author: cryi.liu
 * @Date: 2020-06-10 17:48:00
 * @LastEditTime: 2020-06-11 15:15:35
 * @Description: 考生在线答题数据仓库
 */
export default {
  namespaced: true,

  state: {
    // 考试信息
    examInfo: {},
    // 题目信息
    libraryInfo: [{ libraryVo: {} }],
    // 题目答案
    answerList: [],
  },

  getters: {
    // 获取考试信息
    examInfo({ examInfo }) {
      return examInfo;
    },
    // 获取题目信息
    libraryInfo({ libraryInfo }) {
      return libraryInfo;
    },
  },

  mutations: {
    // 设置考试信息
    setExamInfo(state, { examInfo }) {
      state.examInfo = examInfo;
    },
    // 设置题目信息
    setLibraryInfo(state, { libraryInfo }) {
      state.libraryInfo = libraryInfo;
    },
  },

  actions: {
    invokeSetExamInfo({ commit }, payload) {
      commit('setExamInfo', payload);
    },
    invokeSetLibraryInfo({ commit }, payload) {
      commit('setLibraryInfo', payload);
    },
  },
};
